import React from "react"
import styled, { css } from "styled-components"
import { up } from "styled-breakpoints"
import colors from "@constants/colors"

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  ${up("laptop")} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    column-gap: 20px;
    row-gap: 76px;
  }
`

const mobileBorderStyles = css`
  border-right: solid 1px ${colors.divider};

  ${up("laptop")} {
    border-right: none;
  }
`
const CardWrapper = styled.div<{ mobileBorder: boolean }>`
  border-bottom: solid 1px ${colors.divider};

  ${up("laptop")} {
    border-bottom: none;
  }

  ${({ mobileBorder }) => css`
    ${mobileBorder ? mobileBorderStyles : ""}
  `}
`

interface CardGridProps {
  containerRef?: any
  cards: Array<{
    id: string
  }>
  CardComponent: React.FunctionComponent<any>
}

const CardGrid: React.FC<CardGridProps> = ({
  containerRef,
  cards,
  CardComponent,
}) => {
  return (
    <Container ref={containerRef}>
      {cards.map((card, i) => (
        <CardWrapper key={card.id} mobileBorder={i % 2 === 0}>
          <CardComponent {...card} />
        </CardWrapper>
      ))}
    </Container>
  )
}

export default CardGrid
